import { DEFAULT_ENGINE, POSSIBLE_ENGINES } from '@/utils/search-engines'
import {
  defaultFileName,
  defaultFileNameTooltip,
  noUrlMessage,
  noBooleanStringMessage
} from '@/utils/constants'
import { defaultQueryForDisplay } from '@/graph_parts/default_queries'
import {
  isEmpty,
  keyUndefinedOrNull,
  getDefaultSearchFromName,
  displayQueryNameTrimmed,
  tidyUpQueryData,
  removeUrlPrefix
} from './helper'

export const queryState = {
  state: () => ({
    query: {},
    queryMessage: [],
    booleanString: '',
    polyglotString: '',
    defaultEngine: DEFAULT_ENGINE,
    defaultSourceName: DEFAULT_ENGINE.name,
    possibleEngines: POSSIBLE_ENGINES,
    newQueryName: '',
    newQueryDefaultSearch: null,
    newQueryDefaultSearchName: null,
    newQueryDescription: '', // ?
    newQueryDefaultOperator: '',
    newQueryNewOperator: '',
    newIsPublic: false,
    resultsUrl: '',
    showResultsUrl: true,
    canvasHasTerms: false
    // saveAsName
    // newQueryNotes
  }),
  getters: {
    getResultsURl: state => {
      return state.resultsUrl
    },
    getQuery: state => {
      return state.query
    },
    getQueryIsEmpty: state => {
      return isEmpty(state.query)
    },
    getQuery_id: state => {
      return isEmpty(state.query) ? null : state.query._id
    },
    getQueryName: state => {
      return keyUndefinedOrNull(state.query, 'name') ? null : state.query.name
    },
    getQueryNameForTooltip: state => {
      return keyUndefinedOrNull(state.query, 'name') ? defaultFileNameTooltip : state.query.name
    },
    getQueryNameTrimmed: state => {
      return keyUndefinedOrNull(state.query, 'name') ? defaultFileName : displayQueryNameTrimmed(state)
    },
    getQueryNameIsNull: state => {
      return state.query.name === null
    },
    getQueryNameIsUndefinedNullOrEmpty: state => {
      return typeof state.query.name === 'undefined' ||
        state.query.name === null ||
        state.query.name === ''
    },
    getQueryBody: state => {
      return keyUndefinedOrNull(state.query, 'body') ? null : state.query.body
    },
    getQueryNotes: state => {
      return keyUndefinedOrNull(state.query, 'notes') ? null : state.query.notes
    },
    getQueryDefaultSearchName: state => {
      return keyUndefinedOrNull(state.query, 'defaultSearchName') ? null : state.query.defaultSearchName
    },
    getQueryDefaultOperator: state => {
      return keyUndefinedOrNull(state.query, 'defaultOperator') ? null : state.query.defaultOperator
    },
    getBooleanString: state => {
      return state.booleanString !== '' ? state.booleanString : noBooleanStringMessage
    },
    getQueryIsPublic: state => {
      return keyUndefinedOrNull(state.query, 'isPublic') ? null : state.query.isPublic
    },
    getNewQueryNameNotEmpty: state => {
      return state.newQueryName !== ''
    },
    getNewQueryNameNotEmptyOrNull: state => {
      return state.newQueryName !== '' || state.newQueryName !== null
    },
    getTruncatedUrl: state => {
      return state.canvasHasTerms ? removeUrlPrefix(state.resultsUrl) : noUrlMessage
    },
    getShowUrl: state => {
      return state.canvasHasTerms
    }
    // queryDefaultSearchName: state => {
    //   if (state.query && typeof state.query.defaultSearchName !== 'undefined' && state.query.defaultSearchName !== null) {
    //     return state.query.defaultSearchName
    //   } else {
    //     // @todo - need targeEngine to be added to store
    //     return state.targetEngine.name
    //   }
    // }
  },
  mutations: {
    setQuery: (state, newQuery) => {
      state.query = newQuery
    },
    setQueryToDefaultQueryForDisplay: (state) => {
      state.query = defaultQueryForDisplay()
    },
    setQueryName: (state, queryName) => {
      state.query.name = queryName
    },
    setQueryAndNewQueryName: (state, queryName) => {
      state.query.name = queryName
      state.newQueryDefaultSearchName = queryName
    },
    setQueryNameToNewQueryName: (state) => {
      state.query.name = state.newQueryName
    },
    setQueryBody: (state, queryBody) => {
      state.query.body = tidyUpQueryData(queryBody)
    },
    setQueryDefaultSearchName: (state, queryDefaultSearchName) => {
      state.query.defaultSearchName = queryDefaultSearchName
    },
    setQueryDefaultOperator: (state, queryOperator) => {
      state.query.defaultOperator = queryOperator
    },
    setQueryNotes: (state, queryNotes) => {
      state.query.notes = queryNotes
    },
    setQueryIsPublic: (state, isPublic) => {
      state.query.isPublic = isPublic
    },
    setQueryIsPublicFromNewIsPublic: (state) => {
      state.query.isPublic = state.newIsPublic
    },
    setQueryMessage: (state, newQueryMessage) => {
      state.queryMessage = newQueryMessage
    },
    setBooleanString: (state, booleanString) => {
      state.booleanString = booleanString
    },
    setPolyglotString: (state, polyglotString) => {
      state.polyglotString = polyglotString
    },
    setDefaultEngine: (state, defaultEngine) => {
      state.defaultEngine = defaultEngine
    },
    setNewQueryName: (state, newQueryName) => {
      state.newQueryName = newQueryName
    },
    setNewQueryNameToQueryName: (state) => {
      state.newQueryName = isEmpty(state.query) ? null : state.query.name
    },
    setNewQueryDefaultSearch: (state, newQueryDefaultSearchName) => {
      state.newQueryDefaultSearch = getDefaultSearchFromName(state, newQueryDefaultSearchName)
    },
    setNewQueryDefaultSearchToQueryDefaultSearch: (state) => {
      state.newQueryDefaultSearch = isEmpty(state.query) ? null : getDefaultSearchFromName(state, state.query.defaultSearchName)
    },
    setNewQueryDefaultSearchName: (state, newQueryDefaultSearchName) => {
      state.newQueryDefaultSearchName = newQueryDefaultSearchName
    },
    setNewQueryDescription: (state, newQueryDescription) => {
      state.newQueryDescription = newQueryDescription
    },
    setNewQueryDefaultOperator: (state, newQueryDefaultOperator) => {
      state.newQueryDefaultOperator = newQueryDefaultOperator
    },
    setNewQueryDefaultOperatorToQueryDefaultOperator: (state) => {
      state.newQueryDefaultOperator = isEmpty(state.query) ? null : state.query.defaultOperator
    },
    setNewQueryNotes: (state, newQueryNotes) => {
      state.newQueryNotes = newQueryNotes
    },
    setNewQueryNotesToQueryNotes: (state) => {
      state.newQueryNotes = isEmpty(state.query) ? null : state.query.notes
    },
    setNewIsPublic: (state, newIsPublic) => {
      state.newIsPublic = newIsPublic
    },
    setNewIsPublicToQueryIsPublic: (state) => {
      state.newIsPublic = isEmpty(state.query) ? null : state.query.newIsPublic
    },
    setResultsUrl: (state, resultsUrl) => {
      state.resultsUrl = resultsUrl
    },
    clearResultsUrl: (state) => {
      state.resultsUrl = ''
    },
    setCanvasHasTerms: (state, canvasHasTerms) => {
      state.canvasHasTerms = canvasHasTerms
    }
  },
  actions: {
    setResultsUrl (context, resultUrl) {
      context.commit('setResultsUrl', resultUrl)
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./store/queryState.js
// module id = null
// module chunks = 